"use client";
import { useAuth } from "@ctv/core";
import { Fragment, useEffect } from "react";

import styles from "@ctv/shared/styles/Wrapper.module.css";

type Props = {
  Component: React.JSX.Element;
};

export default function WithDesktopWrapper({ Component }: Props) {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      document.body.classList.add(styles.desktopOnly);
    }
    return () => {
      document.body.classList.remove(styles.desktopOnly);
    };
  }, [isAuthenticated]);

  return <Fragment>{Component}</Fragment>;
}
